<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            <!-- {{ dataId ? '查看' : '新增' }}工单 -->
            回访单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.soRecallHeaderDTO.recallNo
            }}</span>
            <!-- 服务类型 -->
            <span class="information">{{ formData.serverTypeName }}</span>
            <!-- 工单状态 -->
            <!-- 工单状态 -->
            <span class="information" v-if="formData.orderStat == 1">登记</span>
            <span class="information" v-else-if="formData.orderStat == 2">发布</span>
            <span class="information" v-else-if="formData.orderStat == 5">已派网点</span>
            <span class="information" v-else-if="formData.orderStat == 6">网点已接单</span>
            <span class="information" v-else-if="formData.orderStat == 9">已派师傅</span>
            <span class="information" v-else-if="formData.orderStat == 10">师傅已接单</span>
            <span class="information" v-else-if="formData.orderStat == 11">已预约</span>
            <span class="information" v-else-if="formData.orderStat == 13">已出发</span>
            <span class="information" v-else-if="formData.orderStat == 17">已上门</span>
            <span class="information" v-else-if="formData.orderStat == 20">完工暂存</span>
            <span class="information" v-else-if="formData.orderStat == 30">寄修待确认</span>
            <span class="information" v-else-if="formData.orderStat == 31">待寄件</span>
            <span class="information" v-else-if="formData.orderStat == 32">已寄待签收</span>
            <span class="information" v-else-if="formData.orderStat == 36">待维修</span>
            <span class="information" v-else-if="formData.orderStat == 37">修好待寄出</span>
            <span class="information" v-else-if="formData.orderStat == 38">客户待签收</span>
            <span class="information" v-else-if="formData.orderStat == 40">退换待确认</span>
            <span class="information" v-else-if="formData.orderStat == 41">旧机待退回</span>
            <span class="information" v-else-if="formData.orderStat == 42">旧机待签收</span>
            <span class="information" v-else-if="formData.orderStat == 43">旧机已签收</span>
            <span class="information" v-else-if="formData.orderStat == 44">新机待寄出</span>
            <span class="information" v-else-if="formData.orderStat == 45">新机已寄出</span>
            <span class="information" v-else-if="formData.orderStat == 47">新机待签收</span>
            <span class="information" v-else-if="formData.orderStat == 48">新机已签收</span>
            <span class="information" v-else-if="formData.orderStat == 49">退换被驳回</span>
            <span class="information" v-else-if="formData.orderStat == 61">已完工</span>
            <span class="information" v-else-if="formData.orderStat == 62">网点确认完工</span>
            <span class="information" v-else-if="formData.orderStat == 63">中心完工审核</span>
            <span class="information" v-else-if="formData.orderStat == 64">总部完工审核</span>
            <span class="information" v-else-if="formData.orderStat == 91">待结算</span>
            <span class="information" v-else-if="formData.orderStat == 92">结算驳回</span>
            <span class="information" v-else-if="formData.orderStat == 93">结算中止</span>
            <span class="information" v-else-if="formData.orderStat == 94">已结算</span>
            <span class="information" v-else-if="formData.orderStat == 97">申请关闭</span>
            <span class="information" v-else-if="formData.orderStat == 98">挂起</span>
            <span class="information" v-else-if="formData.orderStat == 99">取消</span>
            <span class="information" v-else></span>

            <!-- 紧急度 -->
            <span class="information" v-if="formData.isUrgent == 0">一般</span>
            <span class="information" v-else-if="formData.isUrgent == 1">紧急</span>
            <span class="information" v-else-if="formData.isUrgent == 2">特急</span>
            <span class="information" v-else>未知</span>


          </div>

          <div style="">

            <el-button v-if="formData.finishRecall < 2 && successfulRecall" type="primary" plain class="button-sty"
                       @click="successfulRecallSJ" icon="el-icon-thumb">回访成功
            </el-button>
            <el-button v-if="formData.finishRecall < 2 && failRecall" type="primary" plain class="button-sty"
                       @click="failRecallSJ" icon="el-icon-chat-line-square">
              回访失败
            </el-button>
            <el-button v-if="formData.finishRecall < 2 && rejectCompletion" type="primary" plain class="button-sty"
                       @click="rejectCompletionSJ" icon="el-icon-chat-line-square">
              驳回完工
            </el-button>
          </div>

        </div>

        <div>
          <!-- 基本信息 -->
          <dix style=" overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important ;display:flex ">
            <div class="d-cont edit-mce-box" style="width: 80%;!important">
              <div class="d-item" style="padding-top: 10px;">
                <div class="title first"><b>抽样信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>抽样单号</th>
                    <td>{{ formData.soRecallHeaderDTO.recallNo }}</td>
                    <th>总样本数</th>
                    <td>{{ formData.soRecallHeaderDTO.allOrders }}</td>
                    <th>回访比例</th>
                    <td>{{ formData.soRecallHeaderDTO.rate }}</td>
                    <th>回访数</th>
                    <td>{{ formData.soRecallHeaderDTO.recallOrders }}</td>
                  </tr>
                  <tr>
                    <th>要求回访完成时间</th>
                    <td>{{ formData.soRecallHeaderDTO.recallFinishDate }}</td>
                    <th>指定回访员</th>
                    <td>{{ formData.soRecallHeaderDTO.issueMan }}</td>
                    <th>创建人</th>
                    <td>{{ formData.createBy }}</td>


                  </tr>
                  <tr>
                    <th>生成时间</th>
                    <td>{{ formData.createDate }}</td>
                    <th>工单编号</th>
                    <td>{{ formData.orderNo }}</td>
                    <i class="el-icon-tickets" style="margin:5px 10px;color: #00c4b3;"
                       @click="addressClickEvent(formData.orderId)">查看</i>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item" style="padding-top: 10px;">
                <div class="title first"><b>回访信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>需要回访</th>
                    <td v-if="formData.needRecall == 0">否</td>
                    <td v-if="formData.needRecall == 1">是</td>
                    <th>回访状态</th>
                    <td v-if="formData.finishRecall == 0">待回访</td>
                    <td v-if="formData.finishRecall == 1">回访失败</td>
                    <td v-if="formData.finishRecall == 5">回访成功</td>
                    <th>实际回访员</th>
                    <td>{{ formData.recallMan }}</td>
                    <th>拒访/无应答次数</th>
                    <td>{{ formData.rejectNum }}</td>
                  </tr>
                  <tr>
                    <th>实际回访时间</th>
                    <td>{{ formData.recallDate }}</td>
                    <th>生成时间</th>
                    <td>{{ formData.createTime }}</td>
                  </tr>
                  <tr>
                    <th>呼出结果</th>
                    <td colspan="7">
                      <el-radio v-model="formData.callResult" :label="1">正常呼出</el-radio>
                      <el-radio v-model="formData.callResult" :label="2">无应答</el-radio>
                      <el-radio v-model="formData.callResult" :label="3">拒访</el-radio>
                      <el-radio v-model="formData.callResult" :label="4">空号</el-radio>
                      <el-radio v-model="formData.callResult" :label="5">号码错误</el-radio>
                      <el-radio v-model="formData.callResult" :label="6">其他</el-radio>
                    </td>

                  </tr>
                  <tr>
                    <th>回访情况</th>
                    <td colspan="3">
                      <el-radio-group v-model="formData.huiFangQingKuang" @change="radioHandleChange">
                        <el-radio :label="1">属实</el-radio>
                        <el-radio :label="2">不属实</el-radio>
                        <el-radio :label="3">无果</el-radio>
                      </el-radio-group>
                    </td>

                    <th>不属实原因</th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.notTrueReason" :disabled="isdisabledSite" placeholder=""
                                   @change="updateNotTrueName">
                          <el-option v-for="item in notTrueReasonList" :key="item.value" :label="item.label"
                                     :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </td>

                    <th>无果原因</th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.noResultReason" :disabled="isdisabledNoResult" placeholder=""
                                   @change="updateNoResultName">
                          <el-option v-for="item in noResultReasonList" :key="item.value" :label="item.label"
                                     :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <th>总体满意情况</th>
                    <td colspan="7">
                      <el-radio-group v-model="formData.manYi" @change="radioHandleChange2">

                        <el-radio :label="1">非常满意</el-radio>
                        <el-radio :label="2">满意</el-radio>
                        <el-radio :label="3">一般</el-radio>
                        <el-radio :label="4">不满意</el-radio>
                        <el-radio :label="5">非常不满意</el-radio>
                      </el-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <th>不满意原因</th>
                    <td v-if="!isdisabledSite2">
                      <dict-select dict-type="不满意原因" :disabled="true" :dict-item-id.sync="formData.unSatisfiedReason"
                                   :dict-item-name.sync="formData.unSatisfiedReasonName" />
                    </td>
                    <td colspan="1" v-if="isdisabledSite2">
                      <el-input class="annotate" type="text" placeholder="" size="small" :disabled="isdisabledSite2"
                                v-model="formData.unSatisfiedRemark" clearable></el-input>
                    </td>

                    <th>不满意描述</th>
                    <td colspan="3">
                      <el-input class="annotate" type="text" placeholder="请输入内容" size="small"
                                :disabled="isdisabledSite2" v-model="formData.unSatisfiedRemark" clearable></el-input>
                    </td>
                  </tr>
                  <div style="height: 10px;"></div>
                  <tr>
                    <th>回访备注</th>
                    <td colspan="5">
                      <el-input class="annotate" type="text" placeholder="请输入内容" size="small"
                                v-model="formData.recallRemark" clearable></el-input>
                    </td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <div class="d-item" style="padding-top: 10px;">
                <div class="title first"><b>配件情况</b></div>
                <div>
                  <vxe-table style="margin-top: 5px; width: 90%; margin: 0 auto;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                             height="160" :column-config="{ resizable: true }" :data="formData.soOrderPartsDTOList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="partsCode" title="新配件编码" width="200"></vxe-column>
                    <vxe-column field="partsName" title="新配件名称" width="200"></vxe-column>
                    <vxe-column field="sitePrice" title="零售价" width="130"></vxe-column>
                    <vxe-column field="qty" title="更换数量" width="130"></vxe-column>
                    <vxe-column field="isNeedReturn" title="是否需要返厂" width="120">
                      <template #default="{ row }">
                        <span v-if="row.isNeedReturn == 0">否</span>
                        <span v-else>是</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="isCheck" title="是否属实" width="130">
                      <template #default="{ row }">
                        <el-select v-model="row.isCheck">
                          <el-option label="请选择" :value="0" />
                          <el-option label="属实" :value="1" />
                          <el-option label="不属实" :value="2" />
                          <el-option label="无果" :value="3" />
                        </el-select>
                        <!-- <span v-else>{{ row.isCheck }}</span> -->
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>

              <div class="d-item" style="padding-top: 10px;">
                <div class="title first"><b>回访考核</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>考核科目</th>
                    <td v-if="!billNoDisable" colspan="5">
                      <checkSubjectSearch :check-subject-id.sync="formData.checkSubjectId"
                                          :check-subject-name.sync="formData.checkSubjectName" />
                    </td>
                    <td v-if="billNoDisable" colspan="5">
                      <el-input :disabled="billCheckDisable" class="annotate" type="textarea" :rows="1"
                                placeholder="请输入内容" size="small" v-model="formData.checkSubjectName" clearable></el-input>
                    </td>
                    <th>考核单号</th>
                    <td>{{ formData.billNo }}</td>
                  </tr>
                  <div style="height: 5px;"></div>
                  <tr>
                    <th>考核备注</th>
                    <td colspan="9">
                      <el-input :disabled="billCheckDisable" class="annotate" type="textarea" :rows="1"
                                placeholder="请输入内容" size="small" v-model="formData.checkRemark" clearable></el-input>
                    </td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <div class="d-item" style="padding-top: 10px;">
                <div class="title first"><b>回访项目</b></div>
                <div>
                  <vxe-table style="margin-top: 5px; width: 90%; margin: 0 auto;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                             height="160" :column-config="{ resizable: true }" :data="formData.recallProjectList">
                    <vxe-column field="projectName" title="项目名称" width="200"></vxe-column>
                    <vxe-column field="projectCode" title="项目编码" width="200"></vxe-column>
                    <!--                    <vxe-column field="valueType" title="值类型" width="110" :formatter="formatter4" />-->
                    <vxe-column field="value" title="回访结果" width="130">
                      <template #default="{ row }">
                        <template v-if="row.valueType === 1">
                          <el-input v-model="row.value"></el-input>
                        </template>
                        <template v-else-if="row.valueType === 2">
                          <el-select v-model="row.value">
                            <el-option v-for="option in row.valueSplit.split(';')" :key="option" :label="option"
                                       :value="option"></el-option>
                          </el-select>
                        </template>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
              <div style="height:160px"></div>
            </div>
            <div style="" class="bread">
              <div style="height: 100%; overflow: auto">
                <div class="title_icon"><i class="el-icon-date"></i></div>
                <span style="margin-left: 10px;">回访记录 ({{ formData.soRecallHistoryDTOList != null ?
                  formData.soRecallHistoryDTOList.length : 0
                  }})</span>
                <div>
                  <!-- <div v-if="formData.soRecallHistoryDTOList != null" class="card" v-for="item in formData.soRecallHistoryDTOList">
                  <div><span>回访状态: </span>
                    <span v-if="item.finishRecall == null || item.finishRecall == undefined"></span>
                    <span v-if="item.finishRecall == 0">待回访</span>
                    <span v-if="item.finishRecall == 1">回访失败</span>
                    <span v-if="item.finishRecall == 5">回访成功</span>
                  </div>
                  <div><span>回访时间: </span><span>{{ item.recallDate }}</span></div>

                  <div><span>回访人员: </span><span>{{ item.recallMan}}</span></div>
                  <div><span>回访情况: </span>
                    <span v-if="item.huiFangQingKuang == null || item.huiFangQingKuang == undefined"></span>
                    <span v-if="item.huiFangQingKuang == 1">属实</span>
                    <span v-if="item.huiFangQingKuang == 2">不属实</span>
                    <span v-if="item.huiFangQingKuang == 3">无果</span>
                    </div>
                  <div><span>回访备注: </span><span>{{ item.recallRemark }}</span></div>

                </div> -->

                  <el-timeline class="card_bread" style="height:100%; position:relative">
                    <el-timeline-item v-for="item in formData.soRecallHistoryDTOList" placement="top">
                      <div class="title_time">
                        <span v-if="item.finishRecall == null || item.finishRecall == undefined"></span>
                        <span v-if="item.finishRecall == 0">待回访</span>
                        <span v-if="item.finishRecall == 1">回访失败</span>
                        <span v-if="item.finishRecall == 5">回访成功</span>
                        <span class="span2">{{ item.recallDate }}</span>
                      </div>
                      <el-card class="card">
                        <p>
                          <span>回访人员: </span>
                          <span>{{ item.recallMan }}</span>
                        <div class="details" @click="showDetails( formData.soRecallHeaderDTO.recallNo,item)">详情</div>
                        </p>
                        <p>
                          <span>回访情况: </span>
                          <span v-if="item.huiFangQingKuang == null || item.huiFangQingKuang == undefined"></span>
                          <span v-if="item.huiFangQingKuang == 1">属实</span>
                          <span v-if="item.huiFangQingKuang == 2">不属实</span>
                          <span v-if="item.huiFangQingKuang == 3">无果</span>
                        </p>
                        <p><span>回访备注: </span><span>{{ item.recallRemark }}</span></p>
                      </el-card>
                    </el-timeline-item>

                  </el-timeline>
                </div>


              </div>
            </div>
          </dix>
        </div>
      </el-form>
      <!-- 服务区域弹窗表 -->
      <detailsDialog v-if="showPreconditionDialog2" @closeD="closeD" :row1="row1" :visiable.sync="showPreconditionDialog2"
                     multi="true" />
      <!-- 记录详情 -->
      <showDetailsDialog v-if="showDetailsDialog" @closeD="closeD2" :row1="row2" :workNumber="workNumber"
                         :visiable.sync="showDetailsDialog"
                         multi="true"/>
    </div>
    <!-- <div style="height: 100vh; width: 5px; background-color: aquamarine;"></div> -->
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
// import preconditionDialog from './dialog';
// import areaDialog from './areadialog.vue';
import store from "@/store";
import detailsDialog from "@/views/dialogCommon/detailsDialog.vue";
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue";
// 城市三级联动
// 记录详情
import showDetailsDialog from "@/views/dialogCommon/recordsDetailsDialog.vue";
import {
  regionData,
  CodeToText,
  TextToCode
} from "element-china-area-data";
import api from "@/api/projectApi";
import { mapGetters } from "vuex";
import { dictType, loadDictData } from "@/config/dictType";
import DictSelect from "@/components/formItem/dictSelect.vue";

const cityOptions = ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频', '挂壁式（Q＜3200W）', '挂壁式 3200W≤Q≤3600W 变频'];
const cityOptions2 = ['挂壁式1变频', '挂壁式222变频', '挂壁式3', '挂壁式 4'];
export default {
  name: 'edit',
  props: {
    _dataId: [String, Number],
    multiple: true,

  },
  components: {
    showDetailsDialog,
    checkSubjectSearch,
    DictSelect,
    Tinymce,
    detailsDialog
  },
  data() {
    return {
      workNumber:'',
      row2:'',
      showDetailsDialog: false,

      value1: [],
      radioHandle: "",
      isdisabledSite: true,
      isdisabledNoResult: true,//不属实原因
      isdisabledSite2: true,
      billNoDisable: false,
      billCheckDisable: false,


      showPreconditionDialog2: false,
      show3: false,
      node: true,
      formData: {
        id: null,
        huiFangQingKuang: null,
        finishRecall: null,
        needRecall: null,
        recallMan: null,
        rejectNum: 0,
        recallDate: '',
        manYi: null,
        unSatisfiedReason: null,
        unSatisfiedReasonName: null,
        unSatisfiedRemark: null,
        createTime: null,
        callResult: 1,
        notTrueReason: '',
        recallRemark: '',
        checkRemark: '',
        notTrueReasonName: '',
        billNo: '',
        checkSubjectId: null,
        checkSubjectName: '',
        recallProject: '',
        soRecallHeaderDTO: '',
        soOrderLineDTOList: [],
        soOrderPartsDTOList: [],
        soRecallHistoryDTOList: [],
        recallProjectList: [],

        noResultReason: '',
        noResultReasonName: '',
      },
      sysDictItemList: [],
      checkSubjectList: [],
      notTrueReasonList: [],
      // recallProjectList:[],
      noResultReasonList: [],//无果原因
      successfulRecall: false,
      failRecall: false,
      rejectCompletion: false,

      ////////////////////////////////////////////////////////////////////////////////////////////
      card: true,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      showPreconditionDialog: false,
      checkAll: false,
      checkAll2: false,
      checkedCities: ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频'],
      checkedCities2: ['挂壁式1变频',],
      cities: cityOptions,
      cities2: cityOptions2,
      isIndeterminate: true,
      isIndeterminate2: true,

      img_b: "",
      //认证信息-- 资质照片-测试数据

      big_img: [
        'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
      ],
      // showParameterDialog: false,

      showProductCategoryDialog: false,
      languageDTOs: [],
      dialogImageUrl: '',
      dialogVisible: false,
      uploadDisabled: false,
      upload_img: [

        // imageList: [], //图片数据列表,用于之后上传到后端
        // imageName: []  //图片名称
      ],

      //地址选择
      selectemp: {},
      selectedOptions: [],
      // options: regionData,

    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.successfulRecall = this.permissions["successfulRecall"];
    this.failRecall = this.permissions["failRecall"];
    this.rejectCompletion = this.permissions["rejectCompletion"];
    // console.log(this.formData,"tenant的值");
  },
  mounted() {
    // this.initTableList();
    this.getData();
    this.loadDictData();
    // this.loadRecallProject();
  },
  methods: {

    //选择无果原因
    updateNoResultName() {
      const selectedOption = this.noResultReasonList.find(item => item.value === this.formData.noResultReason);
      if (selectedOption) {
        this.formData.noResultReasonName = selectedOption.label;
      } else {
        this.formData.noResultReasonName = null;
      }
    },

    showDetails(id,row){
      console.log(id,row, "点击的数据")
      this.row2 = row
      this.workNumber=id
      this.showDetailsDialog = true

    },
    closeD2(v) {
      // this.reload()
      console.log(v, "v的值");
      this.showDetailsDialog = v

    },
    radioHandleChange2(val) {
      this.radioHandle = val
      if (val == 4 || val == 5) {
        this.isdisabledSite2 = false
      } else {
        this.isdisabledSite2 = true
        // this.formData.notTrueReason=''

      }
    },
    radioHandleChange(val) {
      this.radioHandle = val
      console.log(val, "选择的val");
      if (val == 2) {
        this.isdisabledSite = false
        this.isdisabledNoResult = true
        if(this.formData.noResultReason != null && this.formData.noResultReason != ''){
          this.formData.noResultReason = ''
          this.formData.noResultReasonName = ''
        }
      } else if(val = 3) {
        this.isdisabledNoResult = false//无果原因
        this.isdisabledSite = true
        if(this.formData.notTrueReason != null && this.formData.notTrueReason != ''){
          this.formData.notTrueReason = ''
          this.formData.notTrueReasonName = ''
        }
      }else {
        this.isdisabledSite = true
        this.isdisabledNoResult = true
        this.formData.notTrueReason = ''
        this.formData.notTrueReasonName = ''
      }
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      //考核科目
      loadDictData(dictType.checkSubject).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.checkSubjectList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      //不属实原因
      loadDictData(dictType.notTrueReason).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.notTrueReasonList.push({
            label: item.label,
            value: item.id
          })
        })
      })

      //无果原因
      loadDictData(dictType.noResultReason).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.noResultReasonList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    // loadRecallProject() {
    //   if (this.dataId && !isNaN(this.dataId)) {
    //     this.isEdit = true;
    //     this.$http({
    //       url: api.visitProject.getRecallProject,
    //       method: 'post',
    //       data: {
    //         id: this.dataId
    //       },
    //       isLoading: true,
    //       modalStrictly: true,
    //     }).then(response => {
    //       this.recallProjectList = response.data.data.records
    //     })
    //   } else {
    //     this.enabled = true;
    //   }
    // },

    successfulRecallSJ() {
      if (this.formData.huiFangQingKuang == 0) {
        this.$message.warning('请先选择回访情况');
        return
      }
      if(this.formData.huiFangQingKuang == 2 && !this.formData.notTrueReason){
        this.$message.warning('选择不属实时必须选择原因');
        return
      }
      if(this.formData.huiFangQingKuang == 3 && !this.formData.noResultReason){
        this.$message.warning('选择无果时必须选择原因');
        return
      }
      this.$baseConfirm('确认判定回访成功吗？').then(() => {
        var url = api.visitProject.successfulRecall
        request({
          url: url,
          method: 'post',
          data: this.formData,
          isLoading: true,
        }).then(response => {
          this.$message({
            message: response.data.content,
            type: 'success',
            duration: 500,
            onClose: t => {
              this.getData();
              // this.$emit('editViewDataUpdate')// 需要刷新页面
            }
          });
        });
      });
    },

    updateNotTrueName() {
      const selectedOption = this.notTrueReasonList.find(item => item.value === this.formData.notTrueReason);
      if (selectedOption) {
        this.formData.notTrueReasonName = selectedOption.label;
      } else {
        this.formData.notTrueReasonName = null;
      }
    },

    addressClickEvent(row) {
      console.log(row, "点击的数据")
      this.row1 = row
      console.log(this.row1, "this.row1ddddddddd");
      this.showPreconditionDialog2 = true


      // this.itemId = row.id
    },

    updateCheckSubjectName() {
      const selectedOption = this.checkSubjectList.find(item => item.value === this.formData.checkSubjectId);
      if (selectedOption) {
        this.formData.checkSubjectName = selectedOption.label;
      } else {
        this.formData.checkSubjectName = null;
      }
    },

    closeD(v) {
      // this.reload()
      console.log(v, "v的值");
      this.showPreconditionDialog2 = v

    },


    failRecallSJ() {
      if (this.formData.huiFangQingKuang != null && this.formData.huiFangQingKuang != 0) {
        if(this.formData.huiFangQingKuang == 3 && !this.formData.noResultReason){
          this.$message.warning('选择无果时必须选择原因');
          return
        }
      }
      this.$baseConfirm('确认判定回访失败吗？').then(() => {
        var url = api.visitProject.failRecall
        request({
          url: url,
          method: 'post',
          data: this.formData,
          isLoading: true,
        }).then(response => {
          this.$message({
            message: response.data.content,
            type: 'success',
            duration: 500,
            onClose: t => {
              this.getData();

              // this.$emit('editViewDataUpdate')// 需要刷新页面
            }
          });
        });
      });
    },


    rejectCompletionSJ() {
      this.$baseConfirm('您确定要将该工单驳回至重新完工吗？').then(() => {
        var url = api.visitProject.rejectCompletion
        request({
          url: url,
          method: 'post',
          data: this.formData,
          isLoading: true,
        }).then(response => {
          this.$message({
            message: response.data.content,
            type: 'success',
            duration: 500,
            onClose: t => {
              this.$emit('editViewDataUpdate')// 需要刷新页面
            }
          });
        });
      });
    },


    submitUpload() {
      this.$refs.upload.submit();
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.visitProject.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          this.formData.id = this.dataId
          if (this.formData.billNo != null && this.formData.billNo != '') {
            this.billNoDisable = true;
            this.billCheckDisable = true;
          }
          if (this.formData.callResult == null) {
            this.formData.callResult = 1
          }
        })
      } else {
        this.enabled = true;
      }
    },
    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    formatter4(row, column) {
      return row.valueType == 1 ? '选项值' : '文本'
    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  float: right;
  margin-right: 10px;
  text-decoration: underline;
  color: #00c4b3;
}

#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }


}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

::v-deep .el-radio {
  width: 65px;
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  width: 20%!important;
  margin-top: 10px;
  margin-left: 5px;

  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 72.5vh;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}


::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}


// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;
  padding: 0 0 0 7px !important;
;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .detail-wrap .d-cont .d-item {
  padding: 5px 0 !important;
}

.gather .el-tab-pane {
  margin-top: 10px;
  padding: 20px 0;

  >>>.el-tabs__active-bar {
    left: 20px !important;
  }

  .el-tabs__nav {
    margin-left: 20px !important;
  }
}

#containt .title b {
  margin-left: 0px !important;
}

::v-deep .product th:after {
  display: none !important;
}

::v-deep .product td {
  padding: 5px 0 !important;

}

::v-deep .vxe-table--render-default .vxe-cell {
  text-align: left !important;
}

.el-image {
  border: dashed 1px #e2e2e2;
  margin-right: 20px;
}

.undergo {
  ::v-deep .el-card.is-always-shadow {
    background-color: #f2f2f2;
    position: relative;
  }

  .el-timeline {
    background-color: #fff;
    padding-left: 10px !important;
    height: 100% !important;
  }

  .el-image {
    width: 60px !important;
    height: 60px !important;
  }

}

::v-deep .el-select__tags>span {
  display: flex !important;
;
}
</style>
